import React, { useEffect } from "react";
import { ImageFolderProps, ImageDesc } from "../../types/globals.types";
import { Button } from "../../blent-component/Button";
import styles from "./styles.module.scss";

interface ImageTreeControleProps {
  root: ImageFolderProps;
  choice?: ImageFolderProps[];
  onActiveImagesChange: (v: ImageFolderProps, images?: ImageDesc[]) => void;
}
export const ImageTreeControle: React.FC<ImageTreeControleProps> = ({
  root,
  onActiveImagesChange,
}) => {
  //if (!root?.subFolders?.length) return null;
  //else

  const handleFolderClick = (folder: ImageFolderProps) => {
    //if not active, unactive all the tree then active this node and all its parents
    const unactiveNodeDeeply = (node: ImageFolderProps) => {
      node.active = false;
      if (node.subFolders?.length) {
        node.subFolders.forEach((x) => unactiveNodeDeeply(x));
      }
    };
    const activateWithParents = (node: ImageFolderProps) => {
      node.active = true;
      if (node.parent) activateWithParents(node.parent);
    };
    unactiveNodeDeeply(root);
    activateWithParents(folder);

    let activeImage = folder.images;

    //if folder has not images but subfolder, so activate the first subfolder that has images
    if (!folder.images?.length && folder.subFolders?.length) {
      folder.subFolders[0].active = true;
      activeImage = folder.subFolders[0].images;
    }
    onActiveImagesChange({ ...root }, activeImage);
  };

  return (
    <div className={styles.imageFilterBtnContainer}>
      {root.subFolders?.map((x, i) => (
        <div key={i}>
          <Button
            corners="squared"
            size="m"
            // label={x.name}
            auto
            onClick={() => handleFolderClick(x)}
            variant={x.active ? "primary" : "secondary"}
          >
            <div className={styles.imageFilterBtn}>
              <span>{x.name}</span>
              <span>{x.count}</span>
            </div>
          </Button>

          {x.active && !x.images?.length && !!x.subFolders?.length && (
            <div className={styles.subfolders}>
              {x.subFolders.map((subFolder, i) => (
                <Button
                  key={i}
                  corners="squared"
                  size="m"
                  auto
                  onClick={() => handleFolderClick(subFolder)}
                  variant={subFolder.active ? "primary" : "secondary"}
                >
                  <div className={styles.imageFilterSubBtn}>
                    <span>{subFolder.name}</span>
                    <span>{subFolder.count}</span>
                  </div>
                </Button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
